var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-pills content-nav"},[_vm._l((_vm.visibleTabs),function(tab){return _c('li',{key:tab.to,class:_vm.isActive(tab) && 'active'},[_c('router-link',{attrs:{"to":tab.to}},[_vm._v(_vm._s(tab.label))])],1)}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }